import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { App } from '@gin-betting/core';
import { useIntl } from 'react-intl';

import { selectOddFormat } from '../../selectors';
import { changeOddFormat } from '../../actions';
import { checkValueInObj } from 'utils';
import globalMsg from 'messages';

interface Output {
    currOddFormat: App.OddFormat;
    title: string;
    filteredOddFormats: App.OddFormat[];
    onMouseDown: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

/* TODO delete App.OddFormat.Fractional in future */
const filteredOddFormats = Object.values(App.OddFormat).filter(
    format => format !== App.OddFormat.Fractional
);

const useOddFormatSelect = (): Output => {
    const { formatMessage } = useIntl();
    const dispatch = useDispatch();
    const currOddFormat = useSelector(selectOddFormat);

    const onMouseDown: Output['onMouseDown'] = useCallback(
        e => {
            const { format: oddFormat } = e.currentTarget.dataset;

            if (!checkValueInObj(App.OddFormat, oddFormat)) return;

            dispatch(
                changeOddFormat({
                    oddFormat,
                })
            );
        },
        [dispatch]
    );

    const title = formatMessage(globalMsg.oddsFormat);

    return {
        currOddFormat,
        title,
        filteredOddFormats,
        onMouseDown,
    };
};

export default useOddFormatSelect;
